<template>
  <div class="page-content-wrapper">
    <div class="card rounded-3 shadow border-1">
      <div
        class="card-header bg-white border-0 me-2 d-flex justify-content-between align-items-center"
      >
        <p class="text-s fw-bold">Applications</p>
      </div>
      <div class="card-body">
        <CustomTable
          :columns="columns"
          :fetchData="get_customer_applications"
          :hasActions="true"
          tableKey="customer_applications"
        >
          <template v-slot:cell-name_email="{ row }">
            {{ row.customer.first_name || row.customer.full_name }}
            {{ row.customer.last_name || "" }}
          </template>
          <template v-slot:cell-date_created="{ row }">
            {{ formatDate(row.date_created) }}
          </template>
          <template v-slot:cell-workflow_name="{ row }">
            {{ row.workflow.workflow_name || "N/A" }}
          </template>
          <template v-slot:cell-completed="{ row }">
            <span
              :class="
                'badge p-2 text-white' +
                (row.application_status === 'Completed'
                  ? ' bg-success'
                  : ' bg-dark')
              "
            >
              {{
                row.application_status === "Completed"
                  ? "Complete"
                  : "Incomplete"
              }}
            </span>
          </template>
          <template v-slot:cell-application_status="{ row }">
            <span
              v-if="row.workflow_application_status"
              class="badge p-2 text-white"
              :style="{
                backgroundColor:
                  row.workflow_application_status.color || '#17a2b8',
              }"
            >
              {{ row.workflow_application_status.status }}
            </span>
            <span v-else class="badge p-2 text-white bg-secondary">
              No Status
            </span>
          </template>
          <template v-slot:actions="{ row }">
            <button
              class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow"
              @click="view_customer_data(customer_id, row.id)"
            >
              View
            </button>
          </template>
        </CustomTable>
      </div>
    </div>
  </div>
</template>
<script src="./customer_applications.js"></script>
